import { useMemo } from 'react';
import { useAsyncResource } from '../../shared/useAsyncResource';
import type { AbsencePort } from './port';
import { fixturePublicHolidayDates, publicHolidayNamesByDate } from './publicHolidayModel';

export function usePublicHolidayDates(port: Pick<AbsencePort, 'listPublicHolidays'>, fixtureMode: boolean, from: string, to: string) {
  const resource = useAsyncResource(
    () => fixtureMode ? Promise.resolve(fixturePublicHolidayDates({ from, to })) : port.listPublicHolidays({ from, to }),
    [port, fixtureMode, from, to],
    '공휴일을 불러오지 못했습니다.',
  );
  const byDate = useMemo(() => publicHolidayNamesByDate(resource.data?.days ?? []), [resource.data]);
  return { ...resource, byDate };
}
